import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const CanFrameDecoderGuidePage = () => <DataDrivenGuidePage slug="guide-can-frame-decoder" />;

export default CanFrameDecoderGuidePage;
